import React from 'react';
import BranchManagerWaiterSection from './BranchManagerWaiterSection.js';

const BranchWaiters = () => {
  return (
    <div>
      <BranchManagerWaiterSection />
    </div>
  );
};

export default BranchWaiters;
